const normalize = value => (value || '').trim().toLowerCase();

const tokens = value => (value || '')
    .split('|')
    .map(token => token.trim().toLowerCase())
    .filter(Boolean);

const isUnfiltered = value => !value || value === 'all';

const init = () => {
    document.querySelectorAll('[data-vacancy-list]').forEach(root => {
        const locationSelect = root.querySelector('[data-vacancy-filter="location"]');
        const positionSelect = root.querySelector('[data-vacancy-filter="position"]');
        const rows = root.querySelectorAll('[data-table-filter="table"] tbody tr');

        const apply = () => {
            const location = normalize(locationSelect?.value);
            const position = normalize(positionSelect?.value);

            rows.forEach(row => {
                const locationMatch = isUnfiltered(location) || tokens(row.dataset.locations).includes(location);
                const positionMatch = isUnfiltered(position) || normalize(row.dataset.positionType) === position;
                row.style.display = locationMatch && positionMatch ? '' : 'none';
            });
        };

        locationSelect?.addEventListener('change', apply);
        positionSelect?.addEventListener('change', apply);
    });
};

init();
